// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609292204/js/" + chunkId + "." + {"44":"a839fe35","225":"15060725","481":"04175ffc","486":"cda67633","770":"c67f9443"}[chunkId] + ".0.31066512312344563.chunk.js";
};